import { useAtom, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { Branch } from "../utils/interfaces";

export const branchDetailsAtom = atomWithStorage<Branch>("branchDetails", null);
const useBranch = () => {
  const atom = useAtom(branchDetailsAtom);
  return atom;
};

export const useSetBranch = () => useSetAtom(branchDetailsAtom);

export default useBranch;
